//typ przekazywanych parametrów 
export type getAttributes = {
  [key: string]: any;
};
export type ArrayInUrlType = {
  name?: string;
  values: ValuesFilterType;
};
export type ValuesFilterType = Array<{ title: string; value: string }>;
export type FilterType = { name: string; values: (string | number)[] };
export type GenerateFiltersArrayPayload = { [key: string]: string | number | string[] | number[] | null };
/** 
 * Klasa dostarczająca funckjonalność budowania adresu url oraz parametrów do jego budowy
 * 
 */
class UrlBuilder {
  /* budowa patha dla wszystkich podanych parametrów */
  public build = (path: string, attributes: getAttributes): string => {
    const converted: Array<string> = [];
    for (const attribute in attributes) {
      if (Object.prototype.hasOwnProperty.call(attributes, attribute)) {
        const element = attributes[attribute];
        const key: string = attribute;
        if (element && typeof element === 'string') converted.push(`${attribute}=${element}`);
        else if (element && typeof element === 'object' && Array.isArray(element)) {
          const isArrayOfStrings = element.reduce((prev: any, current: any) => (typeof prev && typeof current === 'string'), true);
          const isArrayOfObject = element.reduce((prev: any, current: any) => (typeof prev && typeof current === 'object'), true);

          if (isArrayOfStrings) {
            if (element.length) {
              converted.push(this.buildStringArray(element, key));
            }
          }
          else if (isArrayOfObject) {
            if (element.length) {
              for (const singleFilterGroup in element) {
                if (Object.prototype.hasOwnProperty.call(element, singleFilterGroup)) {
                  converted.push(this.buildArray(element[singleFilterGroup], key));
                }
              }
            }
          }
        }
        else if (element && typeof element === 'object' && !Array.isArray(element) && Object.getOwnPropertyNames(element).length) {
          converted.push(this.buildObjectQuery(element));
        }
      }
    }
    return this.concat(converted, path);
  }
  /** 
   * buildArray przyjmuje obiekt z wartością filtra, zwraca częściowego patha
   */
  private buildArray = ({ values, name }: ArrayInUrlType, key: string): string => {
    return values && values.length === 0 ? '' :
      values.reduce((previousValue, currentValue, index) => {
        return `${previousValue}${index === 0 ? '' : '&'}${key}%5B${name}%5D=${currentValue}`;
      }, '');
  }
  /** 
   * buildStringArray przyjmuje wartość filtra, zwraca częściowego patha
   */
  private buildStringArray = (array: Array<string>, key: string): string => {
    return array && array.length === 0 ? '' :
      array.reduce((previousValue, currentValue, index) => {
        return `${previousValue}${index === 0 ? '' : '&'}${key}%5B%5D=${currentValue}`;
      }, '');
  }
  /** 
   * buildObjectQuery przyjmuje obiekt aktywnych filtrów z zaznaczonymi wartościami, zwraca częściowego patha
   * w zależności od typu wartości - zwraca odpowiedni path
   */
  private buildObjectQuery = (params: any): string => Object.keys(params).map(key => {
    if (Array.isArray(params[key])) {
      return params[key].map((item: string) => `filter%5B${key}%5D%5B%5D=${item}`).join('&');
    } else if (!params[key]) return `filter%5B${key}%5D=false`;
    else return `filter%5B${key}%5D=${params[key]}`;
  }).join('&');
  /** concat łączy wszystkie elementy tablicy wprowadzając odpowiednie znaki łączenia parametrów */
  private concat = (array: Array<string>, path: string): string => {
    return array.reduce((previousValue, currentValue, index) => {
      return currentValue === '' ? previousValue : `${previousValue}${index === 0 ? '' : '&'}${currentValue}`;
    }, `${path}?`);
  }
  /** generuje tablicę odpowiednio skonfigurowanych obiektów dla parametru filter */
  public generateFiltersArray = (payload: GenerateFiltersArrayPayload): FilterType[] => {
    const filtersArray: FilterType[] = [];
    Object.entries(payload).forEach(([key, value]) => {
      if (value) {
        if (Array.isArray(value)) {
          value.forEach((item: number | string) => {
            filtersArray.push({ name: key, values: [item] });
          });
        } else {
          filtersArray.push({ name: key, values: [value] });
        }
      }
    });
    return filtersArray;
  }
  /** buduje parametr filter */
  public generateFilterParam = (payload: GenerateFiltersArrayPayload): { filter: FilterType[] } => {
    return { filter: this.generateFiltersArray(payload) };
  }
}

export default new UrlBuilder();